import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormWrapper, FormComponent } from 'src/domains/layouts/shared/cms/form/Form.style';
import { useAppStateContext } from 'src/AppState/AppState';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { OldTextarea } from 'src/domains/layouts/shared/formComponents/textarea/OldTextarea';
import { OldSelect } from 'src/domains/layouts/shared/formComponents/Select/components/OldSelect';
import { SpecialSportsFilters } from 'src/main/cms/SpecialSports/SpecialSportsFilters/SpecialSportsFilters';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const SpecialSportsForm = observer(() => {
    const { cmsState } = useAppStateContext();
    const {
        slug, slugModel, slugStatus,
        label, labelModel, labelStatus,
        sportType, sportTypeOptions,
        sportListOptions,
        competitionIds, competitionIdsModel, competitionIdsStatus,
        handleCreate,
        handleReset,
        resetForm,
        handleEdit,
        isEditMode,
        isLoading,
        iaAddToExistingSportSelected
    } = cmsState.specialSportsState;

    return (
        <FormWrapper>
            <FormHeader isEditMode={isEditMode} defaultLabel='Create new special sport' editModeLabel='Edit special sport' resetForm={resetForm}/>
            <FormComponent onSubmit={(e: React.FormEvent<HTMLFormElement>): void => {
                e.preventDefault();
            }}>
                <Loader isActive={isLoading}/>

                <OldSelect selectOptions={sportTypeOptions} stateValue={sportType} dataTest='select-special-sport-add'/>

                {iaAddToExistingSportSelected ? (
                    <>
                        <OldSelect selectOptions={sportListOptions} stateValue={slug} dataTest='select-sport' />

                        <OldInput
                            label='Label*'
                            status={labelStatus}
                            formInputState={label}
                            model={labelModel}
                            dataTest='add-special-sport-name'
                        />

                        <SpecialSportsFilters />
                    </>
                ) : (
                    <>
                        <OldInput
                            label='Slug* (will be in browser input)'
                            status={slugStatus}
                            formInputState={slug}
                            model={slugModel}
                            dataTest='add-special-sport-slug'
                        />
                        <OldInput
                            label='Label*'
                            status={labelStatus}
                            formInputState={label}
                            model={labelModel}
                            dataTest='add-special-sport-name'
                        />
                        <OldTextarea
                            label='Competition ids (use comma to separate competition ids)'
                            formState={competitionIds}
                            model={competitionIdsModel}
                            status={competitionIdsStatus}
                            dataTest='add-competition-id'
                        />
                    </>
                )}

                <FormButtons
                    onCreate={handleCreate}
                    onUpdate={handleEdit}
                    onCancel={handleReset}
                    isEditMode={isEditMode}
                    dataTestCreate='create-special-sport'
                    dataTestUpdate='update-special-sport'
                />
            </FormComponent>
        </FormWrapper>
    );
});

